<template>
  <v-dialog
    v-model="dialog"
    width="500"
    >
    <v-card
      v-if="selected"
      :key="selected.id"
      >
      <v-card-title>
        Editar pago
      </v-card-title>

      <v-card-text>
        <v-text-field
          label="Monto"
          v-model="selected.amount"
          outlined
          hide-details
          dense
          flat
          ></v-text-field>

        <v-card
          v-if="selected.chargebacks.length"
          color="grey lighten-4"
          class="mt-4 rounded-lg"
          flat
          >
          <v-card-text>
            <div
              class="body-1 font-weight-medium text--primary"
              >
              Este pago tiene intereses por mora de: {{ price(selected.chargebacks[0].amount) }}
            </div>
            <div
              class="caption font-weight-medium text--primary"
              >
              * al día de la fecha de pago
            </div>

            <v-checkbox
              v-model="selected.chargebacks[0].active"
              label="¿Aplicar intereses?"
              @change="changeChargebackActive"
              hide-details
              ></v-checkbox>
          </v-card-text>
        </v-card>

        <create-partial
          :payment="selected"
          :receiptType="receiptType"
          class="mt-3"
          @reload="$emit('reload')"
          ></create-partial>

        <v-card
          color="grey lighten-4"
          class="mt-3 rounded-lg"
          flat
          >
          <v-card-text>
            <div>
              <div
                class="text-subtitle-1 text--primary mb-3"
                >
                Forma de pago:
              </div>

              <div
                >
                <v-radio-group 
                  hide-details
                  class="mt-0 text-h6"
                  :column="false"
                  mandatory
                  v-model="selected.paymentType">
                  <v-radio
                    v-for="n in ['Efectivo', 'Cheque', 'Transferencia']"
                    class="mr-3"
                    :key="n"
                    :label="n"
                    :value="n"
                    ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="edit(selected.id, selected.amount, selected.paymentType)"
          >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CreatePartial from '@/components/payments/partial/Create'

import { EditPayment, SwitchChargeback } from '@/graphql/mutations/payments'

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    selected: {
      type: Object,
      required: true
    },

    receiptType: {
      type: String,
      required: true
    }
  },

  methods: {
    price (amount) {
      const options = { style: 'currency', currency: 'ARS' };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(amount))
    },

    changeChargebackActive (band) {
      this.$apollo.mutate({
        mutation: SwitchChargeback,
        variables: {
          input: {
            id: this.selected.chargebacks[0].id
          }
        }
      }).then( res => {
        this.$emit('reload')
        this.dialog = false
        this.selected = null
      })
    },

    edit (id, amount, paymentType) {
      this.$apollo.mutate({
        mutation: EditPayment,
        variables: {
          input: {
            id: id,
            attributes: {
              amount: amount,
              paymentType: paymentType
            }
          }
        }
      }).then ( res => {
        this.$emit('reload')
        this.dialog = false
        this.selected = null
      })
    },
  },

  components: {
    CreatePartial
  }
}
</script>
